// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/communication/branding/v1/branding.proto (package stailer_service_specification.communication.branding.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/communication/branding/v1/branding.proto.
 */
const file_stailer_service_specification_communication_branding_v1_branding = /*@__PURE__*/
  fileDesc("CkZzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9jb21tdW5pY2F0aW9uL2JyYW5kaW5nL3YxL2JyYW5kaW5nLnByb3RvEjdzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi5jb21tdW5pY2F0aW9uLmJyYW5kaW5nLnYxIo8DCghCcmFuZGluZxJkCghhcHBfbmFtZRgBIAEoCUJSkoIZM+OCouODl+ODquWGheOBp+ihqOekuuOBmeOCi+OCteODvOODk+OCueWQjeOBp+OBmeOAgqqCGQ/jgrXjg7zjg5PjgrnlkI24ghkDwIIZARKZAQoWbGF1bmNoX3NjcmVlbl9zdWJ0aXRsZRgCIAEoCUJ5koIZS+i1t+WLleaZgueUu+mdouOBruODreOCtOOBruS4i+OBq+ihqOekuuOBmeOCi+ODhuOCreOCueODiOOBruaWh+iogOOBp+OBmeOAgqqCGR7otbfli5XnlLvpnaLjgrXjg5bjgr/jgqTjg4jjg6u4ghkDwIIZARKAAQoMY29tcGFueV9uYW1lGAMgASgJQmqSghlR44K144O844OT44K55o+Q5L6b5Lya56S+5ZCN44Gn44GZ44CCV2Vi44OV44OD44K/44O844Gq44Gp44Gn5Yip55So44GV44KM44G+44GZ44CCqoIZCeS8muekvuWQjbiCGQPAghkBYgZwcm90bzM", [file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.communication.branding.v1.Branding.
 * Use `create(BrandingSchema)` to create a new message.
 */
const BrandingSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_communication_branding_v1_branding, 0);


exports.file_stailer_service_specification_communication_branding_v1_branding = file_stailer_service_specification_communication_branding_v1_branding;
exports.BrandingSchema = BrandingSchema;
